import { sample, intersection } from "underscore";

const finished = state => !(state.current === state.total);
const random = state => sample(state.list, 4);
const loaded = state => state.loaded;

const next = state =>
  state.list.find((element, index, array) => {
    let previous = index == 0 ? array.length - 1 : index - 1;

    let a = array[previous].id == state.item.id;

    return a;
  });

const filtered = (state, getters, rootState, rootGetters) => {
  let filteredWorks = state.list.filter(item => {
    let commonTags = intersection(rootGetters["groups/active"], item.groups);

    return commonTags.length > 0;
  });

  return filteredWorks.length > 0 ? filteredWorks : state.list;
};

export default {
  random,
  next,
  filtered,
  finished,
  loaded
};
